import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

import { useI18n } from '@change-corgi/core/react/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { MetaPetitionItemList } from './components/MetaPetitionItemList';
import { MetaRobots } from './components/MetaRobots';
import { usePageMeta } from './hooks/usePageMeta';

export const OG_IMAGE = 'https://static.change.org/brand-pages/impact/opengraph-impact.jpg';

export function PageMeta(): JSX.Element {
	const {
		data: { title, image, lang, slug },
	} = usePageMeta();

	const { translate } = useI18n();
	const { resolveUrl } = useUtilityContext();

	const utilityContext = useUtilityContext();
	const { pathname } = useLocation();
	const canonicalUrl = utilityContext.resolveUrl(pathname);

	return (
		<>
			<Helmet>
				<title>{translate('corgi.topic_page.page_meta.title', { title })}</title>
				<link rel="canonical" href={canonicalUrl}></link>
				<meta property="og:image" content={image} />
				<meta property="og:title" content={translate('corgi.topic_page.page_meta.title', { title })} />
				<meta property="og:description" content={translate('corgi.topic_page.page_meta.description', { title })} />
				<meta property="twitter:image" content={image} />
				<meta property="twitter:image:alt" content={OG_IMAGE} />
				<meta property="twitter:title" content={translate('corgi.topic_page.page_meta.title', { title })} />
				<meta property="twitter:description" content={translate('corgi.topic_page.page_meta.description', { title })} />
				<meta property="og:type" content="website" />
				{lang && <link rel="alternate" hrefLang={lang} href={resolveUrl(`/topic/${slug}`)} />}
			</Helmet>
			<MetaRobots />
			<MetaPetitionItemList />
		</>
	);
}
